import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtros) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/projetos?datainicialetapa=${filtros.dataInicial}&datafinaletapa=${filtros.dataFinal}
                &tipocontratacao=${filtros.tipoContratacao}&natureza=${filtros.natureza}&modulo=${filtros.modulo}&codsolucao=${filtros.codSolucao}
                &todas=${filtros.todas}
            `)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/projetos/${projetoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/etapas/${etapaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/etapas/${etapaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterSolucoes(modulo) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/projetos/solucoes/${modulo}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/gerentes/etapas/${etapaId}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
